"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenAddressToBase58 = exports.tokenAddressFromBase58 = void 0;
var util_1 = require("./util");
Object.defineProperty(exports, "tokenAddressFromBase58", { enumerable: true, get: function () { return util_1.tokenAddressFromBase58; } });
Object.defineProperty(exports, "tokenAddressToBase58", { enumerable: true, get: function () { return util_1.tokenAddressToBase58; } });
__exportStar(require("./CIS2Contract"), exports);
